import DashboardSidebarContainer from './DashboardSidebar.container';

export default DashboardSidebarContainer;
